// Bundle JavaScript spécifique aux profils publics
// Rendu hyper-optimisé pour l'affichage des profils individuels
// Focus sur les performances et l'analytics des visiteurs

// Ahoy JS client — nécessaire pour le tracking côté client (scroll, temps, modules)
// Les visites sont déjà trackées côté serveur (ProfilesController)
import ahoy from "ahoy.js"
// useBeacon: events envoyes via navigator.sendBeacon -> fiable meme quand la page se
// decharge (clic sur lien same-tab). Pas de queue -> pas de doublon. Fiabilise aussi
// le tracking existant (fini le setTimeout 1s qui perdait des events en navigation).
ahoy.configure({ visitDuration: 30, visitsUrl: "/ahoy/visits", eventsUrl: "/ahoy/events", useBeacon: true })
window.ahoy = ahoy

// RGPD : expose window.hasRgpdConsent + configure Ahoy
import { initRgpd } from "./lib/rgpd.js"
initRgpd()

// Utilise l'instance Stimulus partagée depuis stimulus.js (chargé avant)
const application = window.Stimulus

// ===== PROFILS - RENDU OPTIMISÉ =====
// Contrôleurs spécialisés pour l'affichage des profils

// Viewer principal pour les profils
import ViewerController from "./controllers/profiles/viewer_controller.js"
application.register("profiles--viewer", ViewerController)

// Transitions de pages optimisées pour les profils
import ProfilePageTransitionController from "./controllers/profiles/page_transition_controller.js"
application.register("profiles--page-transition", ProfilePageTransitionController)

// Redirections intelligentes pour deep links
import SmartRedirectController from "./controllers/profiles/smart_redirect_controller.js"
application.register("profiles--smart-redirect", SmartRedirectController)

// ===== ANALYTICS & TRACKING =====
// Système de tracking des visiteurs et engagement

import TrackingController from "./controllers/profiles/tracking_controller"
application.register("tracking", TrackingController)

import PageAnalyticsController from "./controllers/profiles/page_analytics_controller"
application.register("profiles--page-analytics", PageAnalyticsController)

import DeepLinkTrackerController from "./controllers/profiles/deep_link_tracker_controller"
// "shared--" : identifiant émis par TracksClicks + Shared::DeepLinkComponent côté Ruby.
// Était enregistré "profiles--deep-link-tracker" → mismatch, le tracker ne se connectait
// jamais (stats platform_interaction + ouverture app native mortes sur les profils).
application.register("shared--deep-link-tracker", DeepLinkTrackerController)

import TextLinksController from "./controllers/profiles/text_links_controller"
application.register("profiles--text-links", TextLinksController)

// ===== UI ESSENTIEL =====
// Composants UI nécessaires pour les profils

import ToastController from "./controllers/shared/ui/toast_controller"
application.register("toast", ToastController)

// Auto-hide des boutons au scroll (mobile)
import ButtonsHideController from "./controllers/profiles/buttons_hide_controller.js"
application.register("profiles--buttons-hide", ButtonsHideController)

// Popup de partage (share, QR, gestion)
import SharePopupController from "./controllers/profiles/share_popup_controller.js"
application.register("profiles--share-popup", SharePopupController)

// RGPD et consentement pour les analytics
import RgpdConsentController from "./controllers/core/rgpd_consent_controller.js"
application.register("rgpd-consent", RgpdConsentController)

// Footer profil (cookie preferences, report, privacy, explore)
import FooterController from "./controllers/profiles/footer_controller.js"
application.register("profiles--footer", FooterController)

// ===== MODULES INTERACTIFS =====
// Controllers pour modules de contenu interactifs

// Media detail popup (YouTube, Audio, Instagram)
import MediaDetailController from "./controllers/profiles/media_detail_controller.js"
application.register("profiles--media-detail", MediaDetailController)

// Clipboard (ex. copier le flux RSS d'un podcast)
import ClipboardController from "./controllers/profiles/clipboard_controller.js"
application.register("profiles--clipboard", ClipboardController)


// Newsletter form
import NewsletterFormController from "./controllers/profiles/newsletter_form_controller.js"
application.register("profiles--newsletter-form", NewsletterFormController)

// Contact form
import ContactFormController from "./controllers/profiles/contact_form_controller.js"
application.register("profiles--contact-form", ContactFormController)

// Image lightbox
import ImageLightboxController from "./controllers/profiles/image_lightbox_controller.js"
application.register("profiles--image-lightbox", ImageLightboxController)

// ===== WEBMCP - AI AGENT TOOLS =====
// Expose structured tools to AI agents via navigator.modelContext

import WebmcpController from "./controllers/profiles/webmcp_controller.js"
application.register("profiles--webmcp", WebmcpController)

import WebmcpDiscoveryController from "./controllers/profiles/webmcp_discovery_controller.js"
application.register("profiles--webmcp-discovery", WebmcpDiscoveryController)

// ===== COMMERCE - CHECKOUT DUAL MODE =====
// Shoppable module : redirect classique + UCP checkout

// Redirect checkout (lien direct vers Shopify)
import RedirectCheckoutController from "./controllers/profiles/redirect_checkout_controller.js"
application.register("profiles--redirect-checkout", RedirectCheckoutController)

// UCP checkout (state machine modal natif)
import UcpCheckoutController from "./controllers/profiles/ucp_checkout_controller.js"
application.register("profiles--ucp-checkout", UcpCheckoutController)

